module.exports = __webpack_public_path__ + "img/mobile-23.80c7d8a2.png";